const config = {
    dependencies: {
        'linear-gradient': require('react-native-web-linear-gradient').default,
    },
};
export default config;